import React, { useEffect, useMemo, useState } from 'react'
import history from 'tools/history'
import { withRouter } from 'react-router-dom'
import { CssBaseline } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { dispatchUccFilters } from 'actions/applicants'
import Auth from 'tools/AuthService'
import Rail from 'components/ds/Rail'
import dynamicIcons from '../../../styles/dynamicIcons'

const RAIL_ICON = 'var(--rail-label)'
const RAIL_ICON_ACTIVE = 'var(--rail-label-active)'

const MenuComponent = (props) => {
  const {
    location: { pathname },
    menuItems,
    collapsed = false,
    onToggle,
  } = props

  const [selectedItem, setSelectedItem] = useState('dashboard')
  const client = useSelector(state => state.user.userDetails.securityContext.client)
  const dispatch = useDispatch()

  useEffect(() => {
    if (pathname === '/create-applicant')
      setSelectedItem(menuItems?.find(ele => ele.id === 'applicants')?.id)
    else {
      const findItem = menuItems
        .filter(ele => pathname.includes(ele.id))
        .sort((a, b) => b.id.length - a.id.length)[0]
      if (findItem) {
        setSelectedItem(findItem.id)
      }
    }
  }, [pathname, menuItems])

  const menuClickAction = (e, item) => {
    if (item.id === 'help') {
      window.open(item.link, '_blank')
    } else {
      dispatch(dispatchUccFilters({}, ''))
      history.push(item.link, 'menu')
    }
  }

  const { sections, footerItems } = useMemo(() => {
    const userRole = Auth.getRoleName()

    const visible = menuItems.filter(item => {
      if (item.id === 'profile') return false

      if (item.id === 'broker-portal') {
        if (userRole === 'BROKER_CUSTOMER') return true
        if (!client?.brokerPortalEnabled) return false
      }

      if (item.id === 'application-offers') {
        if (!client?.readingApplicationsOffersEnabled) return false
      }

      return true
    })

    const toRailItem = ele => ({
      id: ele.id,
      label: ele.label,
      link: ele.link,
      icon: dynamicIcons[ele.icon]
        ? dynamicIcons[ele.icon](selectedItem === ele.id ? RAIL_ICON_ACTIVE : RAIL_ICON)
        : null,
    })

    const grouped = []
    visible.filter(e => e.type !== 'children').forEach(ele => {
      const title = ele.section || null
      let bucket = grouped.find(g => g.title === title)
      if (!bucket) { bucket = { title, items: [] }; grouped.push(bucket) }
      bucket.items.push(toRailItem(ele))
    })

    return {
      sections: grouped,
      footerItems: visible.filter(e => e.type === 'children').map(toRailItem),
    }
  }, [menuItems, selectedItem, client])

  return (
    <>
      <CssBaseline />
      <Rail
        label="Main"
        brand={
          <img
            src={require(`styles/images/menuIcons/${collapsed ? 'iconLogoOnDark' : 'logoOnDark'}.svg`)}
            alt="ROX"
          />
        }
        sections={sections}
        footerItems={footerItems}
        activeId={selectedItem}
        collapsed={collapsed}
        onSelect={menuClickAction}
        onBrandClick={onToggle}
      />
    </>
  )
}

export default React.memo(withRouter(MenuComponent))
